export const COMPARE_PAGE_ID = 'compare';

export const CompoundComparePaneTitle = 'Compare';

export const CompoundComparePaneEvents = Object.freeze({
    /**
     * Opens the pane pre-populated with two compound IDs.
     * data = { compoundIds: [a, b] }
     */
    OPEN_WITH: 'compoundComparePaneOpenWith',
    CLOSE: 'compoundComparePaneClose',
});
